import React from 'react';
const CheckShield = ({ color = 'white', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='18'
      viewBox='0 0 16 18'
      fill='none'
      className={className}
      {...props}
    >
      <path
        d='M6.66467 1.1859L2.67221 2.69009C1.75209 3.03413 1 4.12226 1 5.09838V11.0431C1 11.9873 1.62408 13.2274 2.38417 13.7955L5.82459 16.3638C6.95271 17.2119 8.80894 17.2119 9.93707 16.3638L13.3775 13.7955C14.1376 13.2274 14.7617 11.9873 14.7617 11.0431V5.09838C14.7617 4.11426 14.0096 3.02613 13.0895 2.68208L9.09697 1.1859C8.41689 0.93787 7.32875 0.93787 6.66467 1.1859Z'
        stroke='#0744E1'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.51367 8.89889L6.80179 10.187L10.2422 6.74658'
        stroke='#0744E1'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CheckShield;
